import React from 'react';
import vars from '@variables';
import { H3Atom } from '@atoms/text-atoms/text-atoms';

import { TabTitlesWrapper } from './tab-titles.styles';
import { TabTitlesProps } from './tab-titles.types';

const TabTitles: React.FC<TabTitlesProps> = ({
  tabs,
  activeTab,
  colour = vars.coreDarkGrey,
  className,
  onTabClick,
  parentRef,
  gtmId,
}) => {
  return (
    <TabTitlesWrapper ref={parentRef} className={className} colour={colour}>
      {tabs.map((tab, index) => {
        const dataGtmId = `${gtmId}-${index}`;
        return (
          <li
            key={tab.id}
            className={`tab-title ${index === activeTab ? 'selected' : ''}`}
          >
            <H3Atom
              data-testid={tab.id}
              data-gtm-id={dataGtmId}
              onClick={() => onTabClick(index)}
            >
              {tab.tabTitle}
            </H3Atom>
          </li>
        );
      })}
    </TabTitlesWrapper>
  );
};

export default TabTitles;
